"use client"

import React, { useState } from "react"

import { ExpandableText } from "#components/expandableText"
import { twMerge } from "#lib/twMergeConfig"
import SvgArrowRight from "#svgs/semantic icons/ArrowRight"

export function InfoCard({ title, text, shortText, index }: { title: string; text: string; shortText?: string; index: number }) {
  const [visible, setVisible] = useState(false)

  return (
    <div className={"flex flex-col items-start gap-8 rounded-[19px] border-[1px] border-[#C2C2C2] px-6 py-6 text-nm sm:px-8 sm:text-bg"}>
      <div className={"flex h-10 items-center gap-6 sm:h-12"}>
        <p
          className={
            "relative left-4 z-30 mr-10 flex items-center justify-center text-nm font-black after:absolute after:-z-10 after:size-6 after:rounded-full after:bg-gold-100 after:outline after:outline-4 after:outline-offset-4 after:outline-gold-50 sm:left-6 sm:mr-12 sm:text-[18px] sm:after:size-8 sm:after:outline-offset-[6px]"
          }>
          {index}
        </p>
        <p className={"font-black"}>{title}</p>
      </div>
      <ExpandableText text={text} shortText={shortText} visible={visible} className={"leading-relaxed text-black"} />
      <div className={twMerge("mt-auto flex cursor-pointer gap-1 text-gold-130 transition-colors hover:text-black", visible && "text-black")} onClick={() => setVisible(!visible)}>
        <p className={"font-bold"}>{!visible ? "Mehr Details" : "Weniger Details"}</p>
        <SvgArrowRight className={twMerge("h-6 w-6 transition-transform", visible && "-rotate-90")} />
      </div>
    </div>
  )
}
